import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { showOverlay, hideOverlay } from 'actions/overlay';
import Overlay from 'components/Overlay';
import Platform from 'platform';
import keys from 'config/keys';
import SpatialNavigationWrapper from 'components/navigation/SpatialNavigationWrapper';
import {
  selectIsOverlayOpen,
  selectOverlayType,
  selectOverlayOptions,
  selectOverlayReturnFocusTo,
} from 'reducers/overlay/selectors';

const OverlayContainer = (props) => {
  const { show, backButtonKeyCode, hideOverlay, returnFocusTo, options } = props;

  useEffect(() => {
    const onKeydown = (e) => {
      const { keyCode } = e;
      if (keyCode !== backButtonKeyCode || !show) return;
      e.preventDefault();
      SpatialNavigationWrapper.focus(returnFocusTo);
      if (typeof options.onClose === 'function') options.onClose();
      hideOverlay();
    };
    document.addEventListener('keydown', onKeydown, true);
    return () => document.removeEventListener('keydown', onKeydown, true);
  }, [show, returnFocusTo, options, backButtonKeyCode, hideOverlay]);

  return <Overlay {...props} />;
};

const mapStateToProps = createStructuredSelector({
  show: selectIsOverlayOpen,
  type: selectOverlayType,
  options: selectOverlayOptions,
  returnFocusTo: selectOverlayReturnFocusTo,
  backButtonKeyCode: () => Platform.getKeyCode(keys.BACK),
  downKeyCode: () => Platform.getKeyCode(keys.DOWN),
  upKeyCode: () => Platform.getKeyCode(keys.UP),
});

const mapDispatchToProps = {
  showOverlay,
  hideOverlay,
};

export default connect(mapStateToProps, mapDispatchToProps)(OverlayContainer);
